import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EstateDetails } from '../models/estate-details';
import { siteSpecificData } from '../../../environments/site-specific-data';
import { map } from 'rxjs';

const API_URL = siteSpecificData.apiUrlBase;

@Injectable()
export class EstateDetailsService {
  constructor(private http: HttpClient) { }

  getEstateDetails(estateRef: number): Observable<EstateDetails> {
    const estatesUrl = `${API_URL}estate/${estateRef}/details`;
    return this.http
      .get<EstateDetails>(estatesUrl).pipe(
        map(details => details || undefined)
      );
  }

}
